<router-outlet></router-outlet>
<app-ai-assistant></app-ai-assistant>
